import { VueCropper } from 'vue-cropper';
export default {
  components: {
    VueCropper
  },
  data() {
    return {
      imgUrl: require('../../../assets/nav/user.gif'),
      loading: false,
      modalShow: false,
      option: {
        imgUrl: null,
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true
      },
      previewsImg: {}
    };
  },
  methods: {
    beforeUpload(file) {
      this.loading = true;
      //判断格式
      if (!this.isImage(file)) {
        this.$message.warning(this.$t('只能选择xlxs,xls文件'));
        return false;
      }
      //判断大小
      if (file.size / 1024 / 1024 > 5) {
        this.$message.warning(this.$t('上传图片大小不能超过5M'));
        return false;
      }
      //得先裁剪，然后再走接口上传
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = e => {
        this.option.imgUrl = e.target.result;
        this.loading = false;
        this.modalShow = true;
      };
      return false;
    },
    saveHeadImg() {
      this.$message.success(this.$t('上传成功') + '!');
      this.imgUrl = this.previewsImg.url;
      this.modalShow = false;
    },
    // handleChange(info) {
    //   if (info.file.status === 'uploading') {
    //     this.loading = true;
    //     return;
    //   }
    //   if (info.file.status === 'error') {
    //     this.loading = false;
    //     this.$message.error('上传失败');
    //     return;
    //   }
    //   if (info.file.status === 'done') {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(info.file.originFileObj);
    //     reader.onload = e => {
    //       this.option.imgUrl = e.target.result;
    //       this.loading = false;
    //       this.modalShow = true;
    //     };
    //   }
    // },

    realTime(data) {
      this.previewsImg = data;
    },
    isImage(file) {
      return /\.(gif|jpg|jpeg|png)$/.test(file.name);
    }
  }
};